import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormLabel from '../common/form/FormLabel';
import 'dayjs/locale/ko';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Draggable from 'react-draggable';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';
import { useRef } from 'react';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-emp-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const TaxbillEditModal = ({ open, handleClose, onSave, currentData, editType }) => {
  const dateFocus = useRef();

  const [reqCompDt, setReqCompDt] = useState(new Date());
  const [reqPlanDt, setReqPlanDt] = useState(new Date());
  const [rsltCompDt, setRsltCompDt] = useState(new Date());

  const handleSave = () => {

    if( editType === 'reqPlan' ){
      if (reqPlanDt === null || reqPlanDt === '') {
        alert('발행요청일을 입력하세요');
        dateFocus.current.focus();
        return;
      }
      onSave(reqPlanDt)
    }

    if( editType === 'reqComp' ){
      if (reqCompDt === null || reqCompDt === '') {
        alert('발행완료일일을 입력하세요');
        dateFocus.current.focus();
        return;
      }
      onSave(reqCompDt)
    }

    if( editType === 'rsltComp' ){
      if (rsltCompDt === null || rsltCompDt === '') {
        alert('실적반영일을 입력하세요');
        dateFocus.current.focus();
        return;
      }
      onSave(reqCompDt)
    }

//    editType === 'reqComp' ? : ;
    handleClose();
  };

  useEffect(() => {

    if( editType === 'reqPlan' ){
      setReqCompDt(currentData?.reqPlanDt);
    }
    if( editType === 'reqComp' ){
      setReqCompDt(currentData?.reqCompDt);
    }
    if( editType === 'rsltComp' ){
      setReqCompDt(currentData?.rsltCompDt);
    }

    // if (currentData?.reqCompDt) {
    //   setReqCompDt(currentData?.reqCompDt);
    // }
  }, [currentData]);

  if (!currentData) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-emp-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-emp-dialog"
        onClose={handleClose}
      >
        {currentData?.cstNm} 수정
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
          }}
        >
          <Grid item xs={4}>
            <FormLabel>
              {(() => {
                switch(editType) {
                  case 'reqComp':
                    return '발행완료일';
                  case 'reqPlan':
                    return '발행예정일';
                  default:
                    return '실적반영일';
                }
              })()}
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={8}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="reqCompDt"
                name="reqCompDt"
                value={dayjs(reqCompDt)}
                onChange={(newValue) => {
                  setReqCompDt(dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    sx: { width: 180 },
                    variant: "outlined",
                    size: "small",
                    required: true,
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button variant="outlined" color="inherit" onClick={handleClose}>
          취소
        </Button>
        <Button variant="contained" onClick={handleSave}>
          저장
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default TaxbillEditModal;
